import formName from 'constants/formName'
import { actions, actionTypes, selectors } from 'data'
import { notifyError } from 'data/App/sagas'
import { ProfileFormType, UpdateEmailResponseType } from 'data/types'
import { call, put, select, takeEvery } from 'redux-saga/effects'
import { updateEmail } from 'services/api/user'
import { Response } from 'utils/fetchApi'

const submit = function* () {
  const form: ProfileFormType = yield select(selectors.profile.getValues)
  const email: void | string = yield select(selectors.auth.getEmail)

  yield put(
    actions.form.initialize(formName.CHANGE_EMAIL, {
      loading: true,
      newEmail: form.email,
      oldEmail: email || ''
    })
  )
  yield put(actions.app.showModal('CHANGE_EMAIL'))

  const data: Response<UpdateEmailResponseType> = yield call(updateEmail, {
    email: form.email
  })

  yield put(actions.form.change(formName.CHANGE_EMAIL, 'loading', false))

  if (!data.ok) {
    yield call(notifyError, data.error.cause, 'KO_GENERIC')
    return
  }

  yield put(
    actions.form.change(formName.CHANGE_EMAIL, 'oldEmailVerificationId', data.response.ids[0])
  )
  yield put(
    actions.form.change(formName.CHANGE_EMAIL, 'newEmailVerificationId', data.response.ids[1])
  )
}

export default function* profileMain() {
  yield takeEvery(actionTypes.profile.SUBMIT, submit)
}
